<template>
    <section class="section-title thumb-container" :class="sectionClass + (configuracion.hash_teatro !== 'PTNL6tp97mBUGDchX6d4' ? ' sitecolor-content' : '')" :style='"background-image: url(" + footer.bg3_url + ")"'>
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <h1 :class="'text-uppercase' + (configuracion.hash_teatro === 'PTNL6tp97mBUGDchX6d4' ? ' white' : '')">{{ title }}</h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            title: String,
            sectionClass: String,
        },
        data() {
            return {
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            }
        },
    }
</script>

<style>

</style>
